import axios from '../axios';
import { useQuery } from 'react-query';

export function useGetPartneredChargers() {
  return useQuery('host/charger', () =>
    axios.get('/host/charger').then((res) => res.data),
  );
}
